import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  BUTTON_VARIANTS,
  Input,
  IconClose,
  DialogFooter,
} from 'cdk-radial';
import './APIs.css';
import styled from 'styled-components';
import { validateUrl } from '../../../../../utils/utils';
import {
  updateOrder,
} from '../../../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { DUMMY_WEBHOOK_URL } from '../../../../../constants/APIDirectoryConstants';
import { createPayload } from '../../../OrderAPI/Sub-components/ReviewTerms/ReviewTerms';

const StyledDialog = styled(Dialog)`
  width: 750px;
  border-radius: 8px;
`;

export const APIWebhook = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { authenticationToken: token } = state?.loginDetailsSlice;
  const { updatingOrder, orders, cart } =
    state?.orderAPISlice;
  const [webhook, setWebhook] = useState('');
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [isSavingWebhook, setIsSavingWebhook] = useState(false);

  const { isOpen, handleClose, data } = props;
  const { name, id, webhookUrl } = data;

  const TITLE = 'Webhook';

  useEffect(() => {
    if (webhookUrl && webhookUrl !== DUMMY_WEBHOOK_URL) {
      setWebhook(webhookUrl);
    }
  }, [webhookUrl]);

  const validateWebhookUrl = () => {
    const isUrlValid = validateUrl(webhook, { canBeEmpty: true, https: true });
    setIsValidUrl(isUrlValid);
    return isUrlValid;
  };
  const label = webhookUrl && webhookUrl !== DUMMY_WEBHOOK_URL ? 'Webhook' : 'Enter Webhook URL';

  const handleSaveAsyncApiWebhook = () => {
    if (!validateWebhookUrl()) {
      return;
    }

    let payload = createPayload([], orders);

    let foundInAsyncIntegrations = false;
    payload.asyncApiIntegrations.forEach((f) => {
      if (f.asyncApi.id === data.id) {
        f.webhook = {
          url: webhook,
        };
        foundInAsyncIntegrations = true;
      }
    });

    if (!foundInAsyncIntegrations) {
      handleClose();
      return;
    }

    setIsSavingWebhook(true);
    const updateOrderResult = dispatch(
      updateOrder({
        payload: payload,
        token,
        appId: orders?.app?.id,
        updateWebhook: true,
        webhookApiId: id,
        newWebhookUrl: webhook,
      })
    );

    if (updateOrderResult && typeof updateOrderResult.then === 'function') {
      updateOrderResult
        .then((action) => {
          if (updateOrder.fulfilled.match(action)) {
            handleClose();
          } else if (updateOrder.rejected.match(action)) {
            handleClose();
          }
        })
        .finally(() => {
          setIsSavingWebhook(false);
        });
    } else {
      setIsSavingWebhook(false);
    }
  };

  return (
    <StyledDialog
      id="api-webhook-dialog"
      isOpen={isOpen}
      onClose={handleClose}
      disableOverlayClicked={true}
      hideHeader
      className="webhook-dialog"
      dataTestId="webhook-dialog"
    >
      <div className="webhook-heading-section">
        <div className="webhook-heading">
          {TITLE}
          <IconClose
            className="webhook-heading-close-icon"
            onClick={handleClose}
          />
        </div>
      </div>
      <span className="api-name-span">{name}</span>
      <div className="webhook-input-box">
        <Input
          dataTestId="webhook"
          errorMessage="Website URL must be a valid URL. ex: https://fortellis.io"
          id="webhook-input"
          label={label}
          enableCustomValidation
          placeholder={'Add webhook'}
          hasError={!isValidUrl}
          name="webhook-url"
          onInputClear={() => {}}
          size="standard"
          value={webhook}
          onChange={(e) => {
            setWebhook(e.target.value);
          }}
          onBlur={validateWebhookUrl}
        />
      </div>
      <DialogFooter
        dataTestId='webhook-dialog-footer'
        buttonsProps={[
          {
            id: 'webhook-cancel-btn',
            onClick: handleClose,
            text: 'Cancel',
            variant: BUTTON_VARIANTS.SECONDARY,
          },
          {
            id: 'webhook-save-btn',
            isLoading: updatingOrder || isSavingWebhook,
            onClick: handleSaveAsyncApiWebhook,
            isDisabled: !isValidUrl || !webhook || webhookUrl === webhook,
            text: 'Save',
            variant: BUTTON_VARIANTS.PRIMARY,
          },
        ]}
      />
    </StyledDialog>
  );
};
